export enum PreviewPageType {
    PortalHomePage = "portalHomePage",
    PortalCatalogPage = "portalCatalogPage",
    UnitContentCatalogFolder = "unitContentCatalogFolder",
    UnitsPortalCatalogFolder = "unitsPortalCatalogFolder",
    PortalStandardContentPage = "portalStandardContentPage",
    PortalDepartmentInfo = "portalDepartmentInfo",
    DepartmentInfo = "departmentInfo",
    CareerLobbyPage = "portalCareerLobby",
    PortalEventsPage = "portalEventsPage",
    PortalArticlesPage = "portalArticlesPage"
}